module.exports = __webpack_public_path__ + "static/img/zhhq2.c922f14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhhq2.png
// module id = wQBb
// module chunks = 1